import {useReachGoalCallback} from '@yandex-delivery/blocks'
import {useCallback, useEffect} from 'react'
import {type ControllerRenderProps, useController, useFormContext} from 'react-hook-form'

import {useConfigContext} from '../../../contexts'
import {store} from '../../../store'
import type {SharingProvider} from '../../../types'
import type {Vertical} from '../../types'

export type OuterProps = {
  options: Vertical[]
  form_state_key: string
}

export type InnerProps = {
  options: Vertical[]
  field: ControllerRenderProps
  handleChangeVertical: ControllerRenderProps['onChange']
}

export function useVerticals(config: OuterProps): InnerProps {
  const {options, form_state_key} = config
  const {control, watch, setValue} = useFormContext()
  const {initialProps} = useConfigContext()
  const reachGoal = useReachGoalCallback()

  // дефолтная вертикаль - полученная из url либо первая в списке
  const valueFromUrl = initialProps?.bduiInitialRequest?.state.selected_submode
  const valuesAvailable = options.map(item => item.value)
  const firstValueAvailable = options.length !== 0 ? options[0].value : undefined
  const defaultValue = valueFromUrl && valuesAvailable.includes(valueFromUrl) ? valueFromUrl : firstValueAvailable
  const {field} = useController({name: form_state_key, control, defaultValue})

  const handleChangeVertical = useCallback(
    (verticalId: string) => {
      reachGoal('vertical-tail-click', {verticalId})
      field.onChange(verticalId)
    },
    [field],
  )

  useEffect(() => {
    const currentVertical = options.find(itemProps => itemProps.value === field.value)
    const defaultStateValues = currentVertical?.default_values

    // устанавливаем familiar_vertical_id если вертикаль есть в списке
    // если ее нет - переключаемся на familiar_vertical_id или на первую вертикаль в списке
    if (currentVertical) {
      setValue('familiar_vertical_id', currentVertical.familiar_vertical_id)
      if (defaultStateValues) {
        // если с вертикалью пришли какие-то дефолты, добавляем их в стейт
        Object.keys(defaultStateValues).forEach(key => {
          setValue(key, defaultStateValues[key])
        })
        if (defaultStateValues.sharing_provider) {
          store.state.sharingProvider = defaultStateValues.sharing_provider as SharingProvider
        }
      }
    } else {
      const familiarVerticalName = watch('familiar_vertical_id')
      const familiarVertical = options.find(itemProps => itemProps.value === familiarVerticalName)
      if (familiarVertical) {
        setValue(form_state_key, familiarVertical.value)
      } else setValue(form_state_key, defaultValue)
    }
  }, [watch, setValue, field.value, defaultValue, options, form_state_key])

  return {
    options,
    field,
    handleChangeVertical,
  }
}
